// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"273":"20a3147b","383":"3566e733","536":"56bc7bbe","574":"20a3147b","583":"20a3147b","641":"1b52afa1","778":"20a3147b","900":"04c30c3a","903":"d93a585b"}[chunkId] + ".chunk.css";
};